module.exports = __webpack_public_path__ + "img/turn-draw-default.2d05b955.png";